<template>
  <v-card 
  v-if="viewMode === 'grid'"
  outlined :class="['mrow pa-4 elevation-0', {'disabled': disabled}, {'active-colored-mrow color1--text': currentSelection}, {'backgroundCard': active}]" :v-ripple="!disabled" style="height: 100%;">

    <v-layout align-start>
      <v-avatar tile color="background">
        <img class="c-align-self-start" src="@/assets/img/illustrations/recipe.png" alt="cardboard box" width="76px">
      </v-avatar>
      
      <div class="ml-3">
        <text-highlight style="white-space: initial;" :queries="buildNameKeywords" highlightClass="highlight-class" highlightStyle="">{{ item.name }}</text-highlight>

        <div class="caption">
          <text-highlight style="white-space: initial;" :queries="inventoryItemNameKeywords" highlightClass="highlight-class" highlightStyle="">{{ item.name_inventory_item }}</text-highlight>
        </div>

      </div>

    </v-layout>
  </v-card>
  <div
  v-else-if="viewMode === 'small'"
  :class="['mrow pa-4', {'disabled': disabled}, {'backgroundHover': active}, {'active-colored- color1--text': currentSelection}]" :v-ripple="!disabled">

    <v-layout align-center>
      <img class="c-align-self-start" src="@/assets/img/illustrations/recipe.png" alt="cardboard box" width="66px">
      <div class="ml-3">
        <text-highlight style="white-space: initial;" :queries="buildNameKeywords" highlightClass="highlight-class" highlightStyle="">{{ item.name }}</text-highlight>

        <div class="caption">
          <text-highlight style="white-space: initial;" :queries="inventoryItemNameKeywords" highlightClass="highlight-class" highlightStyle="">{{ item.name_inventory_item }}</text-highlight>
        </div>
        
      </div>
    </v-layout>
  </div>
  <tr v-else-if="viewMode === 'table'"
  :class="[{'active': active}, {'disabled': disabled}, {'active-colored color1--text': currentSelection}]">
    <td>
      <v-layout align-center>

        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="red"
              v-on="on"
            >
              <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0">
            <v-layout class="backgroundCard pa-2 caption">
              JSON
            </v-layout>
            <div class="c-hr"></div>
            <div class="pa-3">
              <span class="caption">
                {{ item }}
              </span>
            </div>
          </v-card>
        </v-menu>

        <text-highlight style="white-space: initial;" :queries="inventoryItemNameKeywords" highlightClass="highlight-class" highlightStyle="">{{ item.name_inventory_item }}</text-highlight>
      </v-layout>
    </td>
    <td>
      <text-highlight style="white-space: initial;" :queries="buildNameKeywords" highlightClass="highlight-class" highlightStyle="">{{ item.name }}</text-highlight>

    </td>
    <td>
      <text-highlight class="text-truncate" :queries="searchFilters.id + ''" highlightClass="color1--text" highlightStyle="background: none;">{{ item.id }}</text-highlight>
    </td>
    <td>
      <v-menu offset-x left open-on-hover max-height="50vh" :disabled="item.items.length < 1">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            :disabled="item.items.length < 1"
            v-on="on"
          >
            <v-icon small>mdi-comment-eye-outline</v-icon>
            <span class="caption">
              {{ item.items.length }}
            </span>
          </v-btn>
        </template>
        <v-card color="" outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            Build {{ item.id }}
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <template v-if="item.items.length > 0">
              <div class="pa-2 font-weight-bold">
                Raw materials
              </div>
              <v-layout v-for="build_item in buildItemsRawMaterials" :key="build_item.id" class="caption mb-2">
                <img class="c-align-self-start" src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="25px">
                <div class="ml-2">
                  <div class="text-ellipsed">
                    {{ build_item.name }}
                  </div>

                  <c-ms-ii
                  :metric_definition="build_item.definition" 
                  :realValue.sync="build_item.quantity"
                  :key="item.id"
                  alwaysScale
                  labelMode
                  ></c-ms-ii>

                </div>
              </v-layout>
              <div class="pa-2 font-weight-bold">
                Packaging
              </div>
              <v-layout v-for="build_item in buildItemsPackaging" :key="build_item.id" class="caption mb-2">
                <img class="c-align-self-start" src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="25px">
                <div class="ml-2">
                  <div class="text-ellipsed">
                    {{ build_item.name }}
                  </div>

                  <c-ms-ii
                  :metric_definition="build_item.definition" 
                  :realValue.sync="build_item.quantity"
                  :key="build_item.id"
                  alwaysScale
                  labelMode
                  ></c-ms-ii>

                  
                </div>
              </v-layout>
            </template>
            <template v-else>
              <span class="caption">
                No items
              </span>
            </template>
          </div>
        </v-card>
      </v-menu>
    </td>
  </tr>
</template>

<script>
import TextHighlight from 'vue-text-highlight'

export default {
  props: ['item', 'viewMode', 'searchFilters', 'disabled', 'active', 'currentSelection'],
  components: {
    TextHighlight
  },
  computed: {
    definition () {
      return this.item
    },
    inventoryItemNameKeywords () {
      return (this.searchFilters.name_inventory_item || '').trim().split(/\s+/)
    },
    buildNameKeywords () {
      return (this.searchFilters.name_build || '').trim().split(/\s+/)
    },
    buildItemsRawMaterials () {
      return this.item.items.filter(item => item.type === 0)
    },
    buildItemsPackaging () {
      return this.item.items.filter(item => item.type === 1)
    }
  },
  watch: {
    active (nv) {
      this.$el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
    }
  }
}
</script>

<style scoped lang="scss">
.mrow {
  cursor: pointer;
  position: relative;
}
.mrow:hover {
  background: var(--v-backgroundHover-base);
}
.disabled {
  opacity: 0.2;

  &.mrow {
    cursor: default!important;
  }
  &.mrow:hover {
    box-shadow: none!important;
  }
}
::v-deep .highlight-class {
  font-weight: bold;
  background: none;
  position: relative;
  color: currentColor;
  

  &::before {
    background-color: currentColor;
    bottom: 0;
    content: "";
    left: 0;
    opacity: 0.22;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: 0.3s 
    }
}
</style>
